import { combineReducers } from '@reduxjs/toolkit'

import { reducer as choicesUser } from './details'

export default combineReducers({ choicesUser })
